import { axios } from '@/lib/axios';

export const login = (data: any): Promise<any> => {
  return axios.post('/api/v1/customers/login', data);
};

export const logout = (): Promise<any> => {
  return axios.post('/api/v1/customers/logout');
};
